import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { IHttpResponse } from '@partners/api';

import { filter, map, tap } from 'rxjs/operators';
import { PolicyService } from '../../process';

/**
 * @description
 * catches all remote (http) errors, which means all server responses with http erroneous status
 * (status > 299 or status < 200).
 * the erroneous status values indicates either:
 *    (1) a technical error (server unavailable | page not found | no internet connection etc')
 *    (2) business logic error (missing data | miscalculation | refusal to service etc')
 *
 * @param request the current http request
 * @param next a method of propagating the request forward to allow interception
 * @returns the next tick in the request process
 */

export const featureConfigInterceptor: HttpInterceptorFn = (request, next) => {
  const policyService = inject(PolicyService);
  // const featureSettings = inject(FEATURE_SETTINGS);

  return next(request).pipe(
    filter((event) => event instanceof HttpResponse),
    map((event) => event as HttpResponse<any>),
    tap((response: HttpResponse<any>) => {
      const { body } = response;
      const { result } = body as IHttpResponse<unknown>;
      if (result?.config) {
        // policyService.updateFeatureConfig();
      }
    })
  );
};

// const context: IHttpContext = ContextBuilder.getContext(request);
// const { resolvers } = context;
